import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, HostBinding, Inject, Input, NgModule, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { LinkModule } from '@app/directives/link.directive';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-commento',
  templateUrl: './commento.component.html',
  styleUrls: ['./commento.component.scss']
})
export class CommentoComponent implements OnInit, OnDestroy {

  @HostBinding('class.w-100') get fullWidth() { return true; }
  @Input() dataPageId: string;

  script: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer2: Renderer2,
    private featureStore: FeatureSettingsStoreService) { }

  ngOnInit(): void {
    const scriptSrc = this.featureStore.state.commentoScriptUrl;
    if (scriptSrc) {
      this.script = this.renderer2.createElement('script');
      this.script.src = scriptSrc;
      if (this.dataPageId) {
        this.script.setAttribute('data-page-id', this.dataPageId);
      }
      this.renderer2.appendChild(this.document.head, this.script);
    }
  }

  ngOnDestroy(): void {
    this.script && this.script.remove();
  }

}
@NgModule({
  declarations: [CommentoComponent],
  exports: [CommentoComponent],
  imports: [
    CommonModule,
    LinkModule,
  ]
})
export class CommentoModule { }
